<template>
  <section v-if="this.$store.state.config['locales'].length > 1" id="languageswitch" class="buttons has-addons">
    <button v-for="lang in this.$store.state.config['locales']" :key="lang" type="button" class="button is-dark has-background-black-bis" @click="setLanguage(lang)">
      <span>{{ lang }}</span>
    </button>
  </section>
</template>

<script>

import map from 'util/MapEngine'

export default {
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
    setLanguage: function (value) {
      this.$store.dispatch('setDisplayLanguage', value)
    }
  }
}

</script>

<style lang="stylus" scoped>

#languageswitch
  position: absolute
  right: 36px
  top: 95px
  z-index: 1002
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11)
  transform: rotate(-90deg)
  transform-origin: top right
  margin: 0
  button
    overflow: hidden
    margin: 0
    padding: 5px 10px
    border-right: 1px solid #7a7a7a
    &:last-child
      border-bottom-right-radius: 0
      border-right: none
    &:first-child
      border-bottom-left-radius: 0
    span
      transform: rotate(90deg)

</style>
